import React, { useCallback, useEffect, useState, useRef } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { useStore } from "stores/connect";
import { Button } from "components/bootstrap";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import UrlAllowListForm from "components/configurations/UrlAllowListForm";
import { ConfigurationsActions, ConfigurationsStore } from "stores/configurations/ConfigurationsStore";
import IfPermitted from "components/common/IfPermitted";
import { isPermitted } from "util/PermissionsMixin";
import generateId from "logic/generateId";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
const URL_ALLOWLIST_CONFIG = "org.graylog2.system.urlallowlist.UrlAllowlist";
const URLAllowListFormModal = ({ newUrlEntry = "", urlType = void 0, onUpdate = () => {
} }) => {
  const prevNewUrlEntry = useRef();
  const [config, setConfig] = useState({ entries: [], disabled: false });
  const [isValid, setIsValid] = useState(false);
  const [newUrlEntryId, setNewUrlEntryId] = useState();
  const [showConfigModal, setShowConfigModal] = useState(false);
  const { configuration } = useStore(ConfigurationsStore);
  const urlAllowListConfig = configuration[URL_ALLOWLIST_CONFIG];
  const currentUser = useCurrentUser();
  const sendTelemetry = useSendTelemetry();
  useEffect(() => {
    if (isPermitted(currentUser.permissions, ["urlallowlist:read"])) {
      ConfigurationsActions.listAllowListConfig(URL_ALLOWLIST_CONFIG);
    }
  }, [currentUser]);
  const setDefaultAllowListState = useCallback(
    (defaultUrlAllowListConfig) => {
      const id = generateId();
      const defaultConfig = {
        entries: [
          ...defaultUrlAllowListConfig.entries,
          {
            id,
            title: "",
            value: newUrlEntry,
            type: urlType != null ? urlType : "literal"
          }
        ],
        disabled: defaultUrlAllowListConfig.disabled
      };
      setNewUrlEntryId(id);
      setConfig(defaultConfig);
    },
    [newUrlEntry, urlType]
  );
  useEffect(() => {
    const { entries } = config;
    if (urlAllowListConfig) {
      if (entries.length === 0 || prevNewUrlEntry.current !== newUrlEntry) {
        setDefaultAllowListState(urlAllowListConfig);
      }
    }
    prevNewUrlEntry.current = newUrlEntry;
  }, [setDefaultAllowListState, urlAllowListConfig, config, newUrlEntry, urlType]);
  const openModal = () => {
    setShowConfigModal(true);
  };
  const closeModal = () => {
    setShowConfigModal(false);
    setDefaultAllowListState(urlAllowListConfig);
  };
  const handleUpdate = (nextConfig, nextIsValid) => {
    setConfig(nextConfig);
    setIsValid(nextIsValid);
  };
  const saveConfig = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    sendTelemetry(TELEMETRY_EVENT_TYPE.URLALLOWLIST_CONFIGURATION_UPDATED, {
      app_section: "urlallowlist",
      app_action_value: "configuration-update"
    });
    if (isValid) {
      ConfigurationsActions.updateAllowlist(URL_ALLOWLIST_CONFIG, config).then(() => {
        onUpdate();
        closeModal();
      });
    }
  };
  if (urlAllowListConfig) {
    const { entries, disabled } = config;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "urlallowlist:write" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xs", onClick: openModal }, "Add to URL allowlist")), /* @__PURE__ */ React.createElement(
      BootstrapModalForm,
      {
        show: showConfigModal,
        bsSize: "lg",
        title: "Update Allowlist Configuration",
        onCancel: closeModal,
        onSubmitForm: saveConfig,
        submitButtonDisabled: !isValid,
        submitButtonText: "Update configuration"
      },
      /* @__PURE__ */ React.createElement("h3", null, "Allowlist URLs"),
      /* @__PURE__ */ React.createElement(
        UrlAllowListForm,
        {
          key: newUrlEntryId,
          urls: entries,
          disabled,
          onUpdate: handleUpdate,
          newEntryId: newUrlEntryId
        }
      )
    ));
  }
  return null;
};
export default URLAllowListFormModal;
